import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import GroupsListPage from '../views/dashboard/groups/GroupsListPage';
import GroupDetailsPage from '../views/dashboard/groups/GroupDetailsPage';
import ChatPage, { ChatEmptyPanel } from '../views/dashboard/chat/ChatPage';
import ChatConversationPage from '../views/dashboard/chat/ChatConversationPage';
import FollowersPage from '../views/dashboard/social/FollowersPage';
import FollowingPage from '../views/dashboard/social/FollowingPage';
import BlockAccountsPage from '../views/dashboard/social/BlockAccountsPage';
import PeopleYouMayKnowPage from '../views/dashboard/social/PeopleYouMayKnowPage';
import InfluencerListPage from '../views/dashboard/social/InfluencerListPage';
import NotificationsPage from '../views/dashboard/social/NotificationsPage';
import FavouriteRecipesPage from '../views/dashboard/social/FavouriteRecipesPage';
import ComingSoonPage from '../views/dashboard/ComingSoonPage';

// GroupChatPage was retired in favor of the unified /chat/:type/:id
// conversation view - this keeps the old /groups/:groupId/chat links
// (bookmarks, other components) working.
const GroupChatRedirect = () => {
  const { groupId } = useParams();
  return <Navigate to={`/chat/group/${groupId}`} replace />;
};

// All authenticated "dashboard" pages render inside the same persistent
// Default layout (header/sidebar/right-sidebar) - this is a flat list of
// route defs, nested under a single <Default/> entry assembled in index.js,
// so navigating between any of these (including app/home) never remounts
// the shared sidebar.
export const ChatRouter = [
  {
    // The old real-data feed page (home-app-page.js) has been retired in
    // favor of the /pages/home prototype screen. Kept as a redirect for old
    // links/bookmarks.
    path: 'app/home',
    element: <Navigate to="/pages/home" replace />,
  },
  {
    path: 'groups',
    element: <GroupsListPage />,
  },
  {
    path: 'groups/:groupId',
    element: <GroupDetailsPage />,
  },
  {
    path: 'groups/:groupId/chat',
    element: <GroupChatRedirect />,
  },
  {
    path: 'chat',
    element: <ChatPage />,
    children: [
      { index: true, element: <ChatEmptyPanel /> },
      { path: ':type/:id', element: <ChatConversationPage /> },
    ],
  },
  {
    path: 'followers',
    element: <FollowersPage />,
  },
  {
    path: 'following',
    element: <FollowingPage />,
  },
  {
    path: 'blocked-accounts',
    element: <BlockAccountsPage />,
  },
  {
    path: 'people-you-may-know',
    element: <PeopleYouMayKnowPage />,
  },
  {
    path: 'influencers',
    element: <InfluencerListPage />,
  },
  {
    path: 'notifications',
    element: <NotificationsPage />,
  },
  {
    path: 'favourite-recipes',
    element: <FavouriteRecipesPage />,
  },
  {
    path: 'my-posts',
    element: <ComingSoonPage title="My Posts" message="Viewing just your own posts isn't available yet." />,
  },
  {
    path: 'ads/create',
    element: <ComingSoonPage title="Create Ad Post" message="Ad creation and payment are still being built." />,
  },
  {
    path: 'ads/my-posts',
    element: <ComingSoonPage title="My Ad Posts" message="Ad creation and payment are still being built." />,
  },
];
